import OptGroup from './OptGroup';
import Option from './Option';
import SelectPropTypes from './PropTypes';
import Select from './Select';
Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;


//////////////////
// WEBPACK FOOTER
// ./~/rc-select/es/index.js
// module id = 164
// module chunks = 0 1 2 3